import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AuthLogin } from '../../API/PostData';
import { AuthData } from '../../Components/Global';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    Username: '',
    Password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  useEffect(() => {
    const Auth = AuthData();
    const token = Cookies.get('auth_token');
    if (Auth && token) {
      navigate('/dashboard');
    } else {
      localStorage.clear();
      Cookies.remove('auth_token');

      navigate('/');
    }
  }, [navigate]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await AuthLogin(formData);

      if (response.status === 200) {
        const randomString = generateRandomString(50);
        // console.log(response);

        // Create date in Indonesia time (UTC+7)
        const expirationTime = new Date(
          new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' })
        );
        expirationTime.setMinutes(expirationTime.getMinutes() + 10);

        Cookies.set('auth_token', randomString, {
          expires: expirationTime,
          path: '/'
        });

        localStorage.clear();
        navigate('/dashboard');
        localStorage.setItem("Auth", JSON.stringify(response.data.data));
        message.success(`Welcome back ${response.data.data.Username}!`);
      }
    } catch (error) {
      console.log(error);
      message.error(error.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const generateRandomString = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="h-screen max-w-screen mx-auto flex items-center justify-center bg-gray-100">
      <div className="max-h-screen-lg max-w-screen-lg w-full flex drop-shadow-md">

        <div className="flex flex-col bg-primary gap-12 py-6 lg:py-20 px-8 lg:px-14 w-full lg:w-1/2 lg:rounded-s-xl mx-4 lg:mx-0">
          {/* <img src="/assets/images/logo-name.png" alt="Logo Icon" className="absolute top-6 left-8 w-40" /> */}

          {/* <h1 className="absolute top-6 left-8 text-[40px] font-medium">CRMS</h1> */}

          <div className="flex flex-col text-[36px] font-medium leading-[44px]">
            <p className="uppercase">Dear Customer</p>
            <p className="text-white uppercase">Welcome - Let's Begin</p>
          </div>

          <div className="my-2">
            <form onSubmit={handleSubmit} method="POST">
              <div className="flex flex-col gap-4">
                <div>
                  <label htmlFor="Username" className="block text-lg font-medium leading-6">
                    Username
                  </label>
                  <div className="mt-2">
                    <input
                      id="Username"
                      name="Username"
                      type="text"
                      required
                      autoComplete="Username"
                      value={formData.Username}
                      onChange={handleChange}
                      placeholder="Username"
                      className="block w-full rounded-md border-0 pl-2 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="Password" className="block text-lg font-medium leading-6">
                    Password
                  </label>
                  <div className="mt-2 relative">
                    <input
                      id="Password"
                      name="Password"
                      type={showPassword ? "text" : "Password"}
                      required
                      autoComplete="current-Password"
                      value={formData.Password}
                      onChange={handleChange}
                      placeholder="Password"
                      className="block w-full rounded-md border-0 pl-2 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                    />
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      className="text-gray-500 hover:text-gray-700 absolute right-2 top-1.5"
                    >
                      {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                    </button>
                  </div>
                </div>
              </div>

              {/* <Link to="">
                <p className="text-right pt-2 text-primary-700 hover:text-primary-400">Forget Password?</p>
              </Link> */}

              <div className="flex justify-end gap-4">
                <button type="submit" className={`${loading ? "bg-second-600" : "bg-second"} hover:bg-second-600 text-white py-2 max-w-32 w-full rounded-md mt-8`} disabled={loading}>
                  {loading ? "Loading..." : "Login"}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="relative w-1/2 overflow-hidden rounded-e-xl hidden md:block bg-white">
          {/* <img
            src="/assets/images/icon.png"
            alt="Icon Intertek"
            className="absolute w-[420px] bottom-0 right-0 translate-x-[74px] translate-y-20"
          /> */}
          <img src="/assets/images/img-login.jpg" alt="Login" className="h-full object-cover object-center" />
        </div>


      </div>
    </div>
  );
}

export default Login;
